<!--接口管理-->
<template>
  <Card dis-hover class="contentArea" style="position: relative">
    <packageTable
      ref="contentBaseRef"
      class="contentBaseRef"
      :tableData="tableData"
      :columnsData="columnsData"
      :loading="tableLoading"
      :tabletotallen="tabletotallen"
      :border="border"
      :stripe="stripe"
      :showSearchBtn="false"
      rowKey="area_name"
      :showSearch="false"
      :tablePageSize="reqBase.page_size"
      @handleLoadData="handleLoadData"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @showSearchParel="showSearchParel"
      @refreshBtn="init"
    >
      <template slot="search">
        <Col span="6">
          <FormItem :label="this.$t('在离线状态')">
                   <Select v-model="form_filter.online_status" filterable>
              <Option
                v-for="(item, i) in select1"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
             <Col span="6">
          <FormItem :label="this.$t('设置状态')">
                   <Select v-model="form_filter.setting_status" filterable>
              <Option
                v-for="(item, i) in select2"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
             <Col span="6">
          <FormItem :label="this.$t('历史下发')">
                   <Select v-model="form_filter.create_time" filterable>
              <Option
                v-for="(item, i) in select3"
                :key="i"
                :value="item"
                >{{ formatDate(item) }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <Button
            v-for="(item, index) in topButtonList"
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
          >{{ item.name }}</Button>
        </Col>
      </template>
      <template slot="headLeft"><div style="margin-left: 1rem;font-size: 1.2rem;">设置设备丨设置名称</div></template>
      <template slot="headRight">
        <Tooltip
          v-for="(item, index) in topButtonList1"
          :key="index"
          :content="item.name"
          placement="bottom"
        >
          <Button
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
          >{{item.name}}</Button>
        </Tooltip>
      </template>
    </packageTable>

  <Modal
  v-model="openModel"
  title="新增"
  :footer-hide="true"
>
 <Form :model="formModel" :label-width="100">
    <FormItem label="产品型号">
            <Input disabled v-model="formModel.input" ></Input>
        </FormItem>
            <FormItem label="硬件版本号">
                  <Select v-model="formModel.hw_ver" filterable>
              <Option
                v-for="(item, i) in modelSelect1"
                :key="i"
                :value="item"
                >{{ item }}</Option
              >
            </Select>
        </FormItem>
            <FormItem label="项目号">
            <Select v-model="formModel.project_id">
                 <Option
                v-for="(item, i) in modelSelect2"
                :key="i"
                :value="item"
                >{{ item }}</Option
              >
            </Select>
        </FormItem>
            <FormItem label="代理商">
            <Select v-model="formModel.merchant_code">
                    <Option
                v-for="(item, i) in modelSelect3"
                :key="i"
                :value="item.merchant_code"
                >{{ item.merchant_name }}</Option
              >
            </Select>
        </FormItem>
          <FormItem label="导入设备id">

    <Upload :value="formModel.filename" type="drag" :before-upload="handleUpload" action="//jsonplaceholder.typicode.com/posts/" >
<div style="padding: 20px 0">
<Icon type="ios-cloud-upload" size="52" style="color: #3399ff" ></Icon>
<p>{{ this.$t("devicelist.uploadxlsx") }}</p>
</div>
</Upload>
          <div>{{ formModel.filename ? formModel.filename.name : "" }}</div>
          </FormItem>
           <a
          style="margin-top: 16px"
          :href="`https://bms-api.xcthings.com/example/example_dids.xlsx`"
          download="uploads_xls.xlsx"
          >{{ this.$t("devicelist.downexample") }}</a
        >
            <FormItem label="设备ID">
            <Input  v-model="formModel.did" placeholder="请输入"></Input>
        </FormItem>
 </Form>

  <!-- 自定义按钮 -->
  <div style="text-align: right; margin-top: 20px;">
    <Button type="default" @click="cancel">取消</Button>
    <Button type="primary" style="margin-left: 10px;" @click="handleOk">确定</Button>
  </div>
</Modal>
  </Card>
</template>

<script>
import packageTableMixins from "@/mixins/packageTableMixins.js";
import axios from "axios";
import { getToken } from "@/libs/util";
import config from "@/config";
import { get_table_data, download_data, del_download } from "@/api/chuku";
import * as XLSX from "xlsx";
export default {
  name: "areaClass",
  mixins: [packageTableMixins],
  data() {
    return {
      setting_id: this.$route.query.setting_id,
      // 新增表单数据
      formModel: {
        input: this.$route.query.model, //did
        hw_ver: null,
        project_id: null,
        merchant_code: null,
        dids: [],
        did: null
      },
      newForm: {
        settingName: "",
        productModel: ""
      },
      select1: [{ name: "在线", value: 2 }, { name: "离线", value: 1 }],
      select2: [
        { name: "完成", value: 2 },
        { name: "失败", value: 3 },
        { name: "等待下发", value: 1 }
      ],
      select3: [],
      modelSelect1: [],
      modelSelect2: [],
      modelSelect3: [],
      openModel: false,
      form_filter: {
        online_status: null,
        setting_status: null,
        create_time: null
      },

      // 顶部按钮
      topButtonList1: [
        {
          name: "全部下发", // 直接使用中文，避免国际化问题
          type: "primary",
          icon: "ios-uplad",
          method: this.allXiafa
        },
        {
          name: "新增", // 直接使用中文，避免国际化问题
          type: "primary",
          icon: "ios-add",
          method: this.addCom
        }
      ],

      topButtonList: [
        {
          name: "查询", // 直接使用中文
          type: "primary",
          method: this.search
        },
        {
          name: "重置", // 直接使用中文
          type: "error",
          method: this.reset
        }
      ],
      tableData: [],
      columnsData: [
        {
          title: "设备ID",
          key: "did",
          align: "left",
          minWidth: 120,
          tree: true
        },
        {
          title: "在离线状态",
          key: "online_status",
          align: "left",
          minWidth: 120,
          tree: true,
          render: (h, { row }) => {
            let result = "";
            let color = "";
            if (row.online_status == 1) {
              color = "error";
              result = this.$t("devicelist.offline");
            } else if (row.online_status == 2) {
              color = "success";
              result = this.$t("devicelist.online");
            }
            return h(
              "Tag",
              {
                props: {
                  color
                }
              },
              result
            );
          }
        },
        {
          title: "设置状态",
          key: "setting_status",
          align: "left",
          minWidth: 120,
          render: (h, { row }) => {
            let result = "";
            let color = "";
            if (row.setting_status == 2) {
              color = "success";
              result = this.$t("完成");
            } else if (row.setting_status == 3) {
              color = "error";
              result = this.$t("失败");
            } else if (row.setting_status == 1) {
              color = "primary";
              result = this.$t("等待下发");
            }
            return h(
              "Tag",
              {
                props: {
                  color
                }
              },
              result
            );
          }
        },
        {
          title: "失败原因",
          key: "error_msg",
          align: "left",
          minWidth: 120,
          tree: true
        },
        {
          title: "下发时间",
          key: "create_time",
          align: "left",
          minWidth: 120,
          tree: true
        },
        {
          title: "操作", // 直接使用中文
          key: "explain",
          align: "center",
          width: 300,
          render: (h, { row }) => {
            let arr = [];
            arr.push(
              h(
                "Button",
                {
                  style: {
                    marginRight: "3px",
                    marginBottom: "3px",
                    color: "#2d8cf0"
                  },
                  props: {
                    size: "small",
                    type: "text"
                  },
                  on: {
                    click: () => {
                      this.setDevice(row);
                    }
                  }
                },
                "下发设置" // 直接使用中文
              )
            );

            return h("div", arr);
          }
        }
      ],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      reqBase: {
        page: 1,
        page_size: 10
      }
    };
  },

  computed: {
    // 避免国际化问题，直接返回中文
    placeholderText() {
      return "请输入";
    }
  },

  components: {},

  methods: {
    fillDefaults(item) {
      item.data.forEach(field => {
        field.value = field.default; // 设置为默认值
      });
    },

    edit(row) {
      console.log("编辑", row);
      // 这里添加编辑逻辑
    },
allXiafa(){
    axios
        .post(
          `https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdeviceapply`,
          {
            access_token: "88ee5af20b0ed69abfc38db7889b7305",
            setting_id: Number(this.setting_id),
            create_time: this.form_filter.create_time,
          }
        )
        .then(res => {
          console.log("设置设备", res);
          if (res.data.result === 0) {
            this.$Message.success("下发成功");
          } else {
            this.$Message.error("下发失败");
          }
        });
},
    setDevice(row) {
      // 这里添加设置设备逻辑
      axios
        .post(
          `https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdeviceapply`,
          {
            access_token: "88ee5af20b0ed69abfc38db7889b7305",
            setting_id: Number(this.setting_id),
            create_time: this.form_filter.create_time,
            did: row.did
          }
        )
        .then(res => {
          console.log("设置设备", res);
          if (res.data.result === 0) {
            this.$Message.success("下发成功");
          } else {
            this.$Message.error("下发失败");
          }
        });
    },

    del(row) {
      console.log("删除row", row);
      this.$Modal.confirm({
        title: "删除",
        content: "确定要删除 " + row.file_url + " 吗？",
        loading: true,
        onOk: function() {}
      });
    },

    addCom() {
      this.openModel = true;
      // 重置表单
      this.newForm = {
        settingName: "",
        productModel: ""
      };
    },

    handleLoadData(item, callback) {
      console.log("11111");
      const vm = this;
      let callbak = res => {
        if (res.result === 0) {
          let data = res.body.list || [];
          for (let i in data) {
            let list = data[i];
            if (list.has_child === 1) {
              list._loading = false;
              list.children = [];
              list.parent_code = item.area_code;
              list.parent_name = item.area_name;
            }
          }
          callback(data);
        } else {
          // 处理错误
        }
      };
      // area_list({
      //   page_size: -1,
      //   page: 1,
      //   parent_code: item.area_code,
      //   all: 1
      // })
      //     axios
      //     .post(`https://cn3.api.xcthings.com:6443/v3/smartbms/bmssettinglist`, {
      //        page: 1,
      //         page_size: 1,
      //         setting_name:this.form_filter.country_code,
      //         access_token: getToken()
      //     })
      // .then(res => {
      //   console.log('DSADSADA',res);

      //   callbak(res);
      // })
      // .catch(err => {
      //   // 处理错误
      // });
    },

    init() {
      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 初始化数据
     */
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.toLocaleString();
    },
    getData() {
      console.log('this.form_filter',this.form_filter);
 this.tableData=[]
      axios
        .post(
          `https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdevice`,
          {
            access_token: "88ee5af20b0ed69abfc38db7889b7305",
            setting_id: Number(this.setting_id),
            online_status: this.form_filter.online_status,
            setting_status: this.form_filter.setting_status,
            create_time: this.form_filter.create_time
          }
        )
        .then(res => {
          this.tabletotallen = res.data.body.total;
          this.tableData = res.data.body.info.map(item => {
            return {
              ...item,
              create_time: this.formatDate(item.create_time)
            };
          });
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },

    /**
     * 翻页
     */
    pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel() {
      this.$refs.search.expandPanel();
    },

    search() {
      this.init();
    },

    reset() {
      this.form_filter = {
        online_status: null,
        setting_status: null,
        create_time: null
      };
      this.search();
    },

    handleOk() {
      // 检查是否有勾选的组
if (this.formModel.did) {
  // 使用中文逗号拆分字符串
  const ids = this.formModel.did.split('-').map(id => id.trim());

  // 清空 dids 数组，确保不重复添加
  this.formModel.dids = [];

  // 将每个 ID 添加到 dids 数组中
  ids.forEach(id => {
    if (id) { // 检查 ID 是否不为空
      this.formModel.dids.push(id);
    }
  });
}

// 输出 dids 以进行调试
console.log(this.formModel.dids);
      axios
        .post(
          `https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdeviceadd`,
          {
            access_token: "88ee5af20b0ed69abfc38db7889b7305",
            setting_id: Number(this.setting_id),
            hw_ver: this.formModel.hw_ver,
            project_id: this.formModel.project_id,
            merchant_code: this.formModel.merchant_code,
            dids: this.formModel.dids
          }
        )
        .then(res => {
          if (res.data.result === 0) {
            this.$Message.success("新增成功");
            this.getHistory();
            this.openModel = false;
            this.formModel = {
              input: this.$route.query.model, //did
              hw_ver: null,
              project_id: null,
              merchant_code: null,
              dids: [],
              did: null
            };
          } else {
            this.$Message.error("新增失败");
          }
        });
    },

    cancel() {
      console.log("取消");
      this.openModel = false;
      this.formModel = {
        input: this.$route.query.model, //did
        hw_ver: null,
        project_id: null,
        merchant_code: null,
        dids: [],
        did: null
      };
    },
    handleUpload(file) {
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // 获取工作表数据
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        let jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
        jsonData = jsonData.slice(1).flat();

        console.log(jsonData); // 输出处理后的数据
        this.formModel.dids = jsonData;
        // 在此处处理数据，例如存入状态管理或进一步处理
      };
      reader.readAsArrayBuffer(file);
      return false;
    },
    // 获取历史下拉
    getHistory() {
      axios
        .post(
          `https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdevicehis`,
          {
            setting_id: Number(this.setting_id),
            access_token: "88ee5af20b0ed69abfc38db7889b7305"
          }
        )
        .then(res => {
          console.log("resres", res.data.body.history);
          this.select3 = res.data.body.history;
          this.form_filter.create_time = res.data.body.history[0];
        });
    }
  },

  mounted() {
    this.$set(this.reqBase, "project_code", this.$store.state.user.projectCode);
    this.getHistory();
    setTimeout(() => {
      this.init();
    }, 1000);
    axios
      .post(
        `https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingselector`,
        {
          php_token: getToken(),
          access_token: "88ee5af20b0ed69abfc38db7889b7305"
        }
      )
      .then(res => {
        this.modelSelect1 = res.data.body.hw_ver;
        this.modelSelect2 = res.data.body.project_id;
        this.modelSelect3 = res.data.body.info;
      });
  },

  created() {},

  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped>
.btnFormItem /deep/ .ivu-form-item-content {
  margin-top: 30px;
}
.searchForm /deep/ .ivu-form-item {
  margin-bottom: 5px;
}

/* 确保Modal内容正确显示 */
.ivu-modal-body {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
